import { TextField, Autocomplete, createTheme } from '@mui/material';

export const theme = createTheme({
  components: {
    MuiFormLabel: {
      styleOverrides: {
        asterisk: { color: 'red' },
      },
    },
  },
});
const ConditionalDropdown = ({
  data,
  setCondition,
  secondstate,
  label,
  id,
  state,
  setState,
  getValues,
  register,
  validation,
  errors,
}) => {
  const [personName, setPersonName] = React.useState([]);

  return (
    <>
      <Autocomplete
        disablePortal
        autoHighlight
        id={id}
        options={data}
        getOptionLabel={(option) => option.label}
        defaultValue={getValues(state)}
        onChange={(e, val) => {
          setState(state, val.value);
          setCondition(val.label);
          secondstate && setState(secondstate, val.id);
          secondstate && setPersonName(getValues(state));
        }}
        renderInput={(params) => (
          <>
            {validation ? (
              <TextField
                {...params}
                fullWidth
                name={state}
                type="text"
                label={label}
                {...register(state, {
                  required: '*Field is required and needs to be a text',
                })}
                helperText={Boolean(errors[`${state}`]) ? errors[`${state}`]?.message : ''}
                error={Boolean(errors[`${state}`])}
                InputLabelProps={{ shrink: true }}
              />
            ) : (
              <TextField
                {...params}
                fullWidth
                type="text"
                {...register(state)}
                label={label}
                InputLabelProps={{ shrink: true }}
              />
            )}
          </>
        )}
      />
    </>
  );
};
export default ConditionalDropdown;
